var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeambt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 10 10",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M1 1h4M1 2h1m3 0h4M1 3h1m6 0h1M1 4h1m5 0h1M2 5h1m3 0h1M2 6h1m2 0h1M2 7h1m1 0h1M2 8h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6c848e",
    d: "M2 2h3M2 3h1M2 4h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2d4e93",
    d: "M3 3h4M3 4h3M3 5h2M3 6h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#292c7c",
    d: "M7 3h1M6 4h1M5 5h1M4 6h1M3 7h1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeambt);
export default __webpack_public_path__ + "static/media/teambt.4b65d1face3a99cfd8ae116c1ab2bf2f.svg";
export { ForwardRef as ReactComponent };